import React, { useEffect, useMemo, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { useDispatch, useSelector } from 'react-redux';
import { getFetchObject } from './utils/notificationsHelper.js';
import { useFetch } from './filters/useFetch.js';
import { deleteContrainteNotification } from './actions/notifications.js';
import { createPlayer, mergePlayer } from './actions/players.js';

const Notifications = () => {

    const notifications = useSelector((state) => state.notification)

    return (
        <div>
            {notifications && notifications.contraintes.map(notification => 
                <Notif idObject={notification.idObject} typeObject={notification.typeObject}></Notif>
            )}
            {notifications && notifications.duplications.map(duplication => 
                <NotifDuplicate duplicates={duplication.duplicates} typeObject={duplication.typeObject} objectToCreate={duplication.objectToCreate}></NotifDuplicate>
            )}
            {notifications && notifications.confirmActions.map(confirmAction => 
                <NotifConfirm label={confirmAction.label} action={confirmAction.action}></NotifConfirm>
            )}
        </div>
         
    )


}

const Notif = ({idObject, typeObject}) => {

    const dispatch = useDispatch()

    // On récupère l'objet en base
    const {url, deleteUrl, label} = getFetchObject(typeObject)
    const filters = useMemo(() => {
        return {_id : idObject, __force__ : true}
    }, [idObject])

    const [objectToDelete, loading] = useFetch(url, filters, undefined, '')

    useEffect(() => {
        if(objectToDelete && objectToDelete[0]){
            setOpen(true)
        }else{
            setOpen(false)
        }

    }, [objectToDelete])

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        if(objectToDelete && objectToDelete[0])
            dispatch(deleteContrainteNotification(objectToDelete[0]._id))
    };

    if(!objectToDelete || !objectToDelete[0])
        return <></>

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Une erreur est survenue lors de la suppression de l'élément"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Attention, pour effectuer cette action vous devez supprimer {label(objectToDelete[0])}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Annuler</Button>
            <Button onClick={() => dispatch(deleteUrl(objectToDelete[0]._id))} autoFocus>
                Oui, je veux supprimer {label(objectToDelete[0])}
            </Button>
            </DialogActions>
        </Dialog>
    )
}

const NotifConfirm = ({label, action}) => {

    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false)
    };

    return <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
        {"Confirmer l'action"}
        </DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {label}
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={() => {action(); handleClose()}}>Confirmer</Button>
        <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
    </Dialog>

}

const NotifDuplicate = ({duplicates, typeObject, objectToCreate}) => {

    const dispatch = useDispatch()

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false)
    };

    const handleCreate = () => {
        dispatch(createPlayer(objectToCreate, true))
        handleClose()
    }

    const handleMerge = () => {
        if(!selectedRow)
            return

        dispatch(mergePlayer(objectToCreate, selectedRow._id))
        handleClose()
    }

    /*if(!objectToDelete || !objectToDelete[0])
        return <></>*/

    return (
        <Dialog
            open={open}
            //onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Une erreur est survenue lors de la creation de l'élément"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Le joueur que vous essayez de créer existe deja. Choisissez-le parmi la liste suivante pour l'éditer : 
                <PlayerTable players={duplicates} setSelectedRow={setSelectedRow} selectedRow={selectedRow}/>
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCreate}>Créer un nouveau joueur</Button>
            {selectedRow && <Button onClick={handleMerge}>Editer le joueur selectionné</Button>}
            <Button onClick={handleClose}>Annuler</Button>
            </DialogActions>
        </Dialog>
    )
}

const PlayerTable = ({ players, setSelectedRow, selectedRow }) => {
    
    const [hoveredRow, setHoveredRow] = React.useState(null);
  
    const handleRowClick = (row) => {
      setSelectedRow(row);
      // Ajoutez ici la logique à exécuter lorsqu'une ligne est cliquée
    };

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Prénom</TableCell>
              <TableCell>Equipes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {players.map((player) => (
              <TableRow
                key={player._id}
                onClick={() => handleRowClick(player)}
                onMouseEnter={() => setHoveredRow(player)}
                onMouseLeave={() => setHoveredRow(null)}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: selectedRow === player ? '#eaeaea' : hoveredRow === player ? '#eaeaea' : 'inherit',
                }}
              >
                <TableCell>{player.lastname}</TableCell>
                <TableCell>{player.firstname}</TableCell>
                <TableCell>{player.teams.map((t, index) => <span key={t._id}>{t.name}{index !== player.teams.length - 1 ? ', ' : ''}</span>)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  

export default Notifications